"use strict";

exports.__esModule = true;
/**
 * @hidden
 */

function isSortOnSpec(sortSpec) {
  return sortSpec.sortOn !== undefined;
}

exports.isSortOnSpec = isSortOnSpec;